<template>
	<div id="shows">
		<div class="flexContainer">
  			<div class="navBox">
				<div class="navItem"
					 :class="{ navItemActive: selectedNavItem === navItem}"
					 v-for="(navItem, index) in navItems"
					 :key="index"
					 v-on:click="filterShows(navItem)">
					{{ navItem }}
				</div>
				<SearchBar class="searchBar" placeholder="Shows durchsuchen"/>
			</div>
  			<div class="contentBox">
				<ShowList v-bind:showList="showList" v-bind:editable="isEditable"/>
			</div>
		</div>
	</div>
</template>

<script>
	import ShowList from '@/components/shows/ShowList.vue';
	import Show from '@/services/Show';
	import isLoggedIn from '@/services/IsLoggedIn.js';
	import SearchBar from '@/components/SearchBar.vue';
	import {EventBus} from '@/services/EventBus.js';

	export default {
		name: "Shows",
		components: {
			ShowList,
			SearchBar
		},
		props: {
			isEditable: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
				showList: [],
				publicShowList: [],
				privateShowList: [],
				navItems: ['Öffentliche Shows', 'Interne Shows'],
				selectedNavItem: 'Öffentliche Shows'
			}
		},
		methods: {
			searchForShow(query) {
				this.showList = [];
				var allShows = this.publicShowList.concat(this.privateShowList);
				this.showList = allShows.filter(show => {
					return (show.title.toLowerCase().search(query)>=0);
				});
			},
			filterShows(navItem) {
				this.showList = [];
				this.selectedNavItem = navItem;
				this.showList = (navItem === 'Öffentliche Shows') ? this.publicShowList : this.privateShowList;
			}
		},
		async created() {
			(await isLoggedIn() === false) ? this.$router.push('/login') : '';

			let shows = await Show.getAll();
			shows.forEach(show => {
				show.is_Public ? this.publicShowList.push(show) : this.privateShowList.push(show);
			});

			this.showList = this.publicShowList;

			EventBus.$on('onSearch', queryString => {
				this.searchForShow(queryString);
				this.selectedNavItem = '';
			});

			EventBus.$on('onDeleteSearch', e => {
				console.log(e);
				this.filterShows(this.navItems[0]);
			});

			EventBus.$emit('onCurrentShow', '');

		},
		async mounted() {
			await !isLoggedIn() ? this.$router.push('/login') : '';
		}
	}
</script>

<style scoped>
	
	#shows .flexContainer .navBox {
		padding-top: 20px;
	}

	#shows .flexContainer .navBox .navItemActive {
		padding-left: 40px;
	}

	.contentBox {
		overflow: auto;
		max-width: 100%;
	}
	
</style>
